import { createSlice } from '@reduxjs/toolkit';
import {
  patchAgent,
  fetchAgentById,
  fetchAgentLiveTransferRequestsByDealId,
} from './actions';
import Agent from '../../interfaces/agent';
import { AgentLiveTransferRequest } from './types';
import { searchDealsById } from '../deals/actions';

interface AgentsStore {
  hasErrors: boolean;
  loading: boolean;
  agentsMap: { [key: string]: Agent };
  agentsCallingRequest: { [key: string]: 'pending' | 'fulfilled' | 'rejected' };
  selectedAgents: Agent[];
  selectedAgentId: string | null;
  agentLiveTransferRequests: AgentLiveTransferRequest[];
}

const initialState: AgentsStore = {
  hasErrors: false,
  loading: true,
  agentsMap: {},
  agentsCallingRequest: {},
  selectedAgents: [] as Agent[],
  selectedAgentId: null as string | null,
  agentLiveTransferRequests: [],
};

const agentsSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setSelectedAgentId(state, action) {
      state.selectedAgentId = action.payload;
    },
    setIsLoading(state, action) {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Async agent fetch
    builder.addCase(fetchAgentById.pending, (state, { meta }) => {
      state.agentsCallingRequest[meta.arg] = 'pending';
    });
    builder.addCase(fetchAgentById.fulfilled, (state, { meta, payload }) => {
      state.agentsMap[meta.arg] = { ...payload, id: meta.arg };
      state.hasErrors = false;
    });
    builder.addCase(fetchAgentById.rejected, (state) => {
      state.hasErrors = true;
    });
    builder.addCase(patchAgent.pending, (state, { meta }) => {
      state.agentsCallingRequest[meta.arg.id] = 'pending';
    });
    builder.addCase(patchAgent.fulfilled, (state, { meta, payload }) => {
      state.agentsMap[meta.arg.id] = { ...payload, id: meta.arg.id };
      state.hasErrors = false;
    });
    builder.addCase(patchAgent.rejected, (state) => {
      state.hasErrors = true;
    });
    builder.addCase(
      fetchAgentLiveTransferRequestsByDealId.fulfilled,
      (state, { payload }) => {
        if (!payload) return;
        state.agentLiveTransferRequests = payload;
      },
    );
    builder.addCase(searchDealsById.fulfilled, (state) => {
      state.agentLiveTransferRequests = [];
    });
  },
});

export const { setSelectedAgentId, setIsLoading } = agentsSlice.actions;

// Reducer
export default agentsSlice.reducer;
